// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"98dbb6f0","225":"1f61a835","340":"cecf1e19","421":"d86e84c6","449":"6f04b991","453":"2f6b8565","840":"cc4505c9"}[chunkId] + ".chunk.js";
};